import { FC } from 'react';
import { HtmlContentProps } from './types/propTypes';
import styles from './HtmlContent.module.scss';

const HtmlContent: FC<HtmlContentProps> = ({ content }) => (
  <div
    className={styles['html-content']}
    dangerouslySetInnerHTML={{
      __html: content,
    }}
  />
);
export default HtmlContent;
